import Header from '../../components/feature/Header';
import Footer from '../../components/feature/Footer';

export default function CodeOfConduct() {
  return (
    <div className="min-h-screen bg-white">
      <Header />
      <main className="pt-20">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
          <div className="prose prose-lg max-w-none">
            <h1 className="text-4xl font-bold text-gray-900 mb-8">Fast Funding Capital – Code of Conduct</h1>
            
            <div className="bg-blue-50 border-l-4 border-blue-600 p-6 mb-8">
              <p className="text-lg text-gray-700 leading-relaxed">
                At Fast Funding Capital, we hold ourselves and our partners to the highest standards of integrity, professionalism, and client respect. This Code of Conduct defines how we operate and serve every client seeking commercial mortgage solutions.
              </p>
            </div>

            <section className="mb-8">
              <div className="flex items-center mb-4">
                <div className="w-10 h-10 bg-blue-600 rounded-lg flex items-center justify-center mr-4">
                  <i className="ri-shield-check-line text-xl text-white"></i>
                </div>
                <h2 className="text-2xl font-semibold text-gray-900">1. Integrity First</h2>
              </div>
              <ul className="list-disc pl-6 text-gray-700 space-y-2">
                <li>We provide honest, transparent information about every product and service.</li>
                <li>No false claims, hidden terms, or misleading promises are tolerated.</li>
              </ul>
            </section>

            <section className="mb-8">
              <div className="flex items-center mb-4">
                <div className="w-10 h-10 bg-blue-600 rounded-lg flex items-center justify-center mr-4">
                  <i className="ri-lock-line text-xl text-white"></i>
                </div>
                <h2 className="text-2xl font-semibold text-gray-900">2. Confidentiality and Data Protection</h2>
              </div>
              <ul className="list-disc pl-6 text-gray-700 space-y-2">
                <li>All client information is handled with strict confidentiality.</li>
                <li>We protect personal and business data in compliance with federal and state privacy laws.</li>
              </ul>
            </section>

            <section className="mb-8">
              <div className="flex items-center mb-4">
                <div className="w-10 h-10 bg-blue-600 rounded-lg flex items-center justify-center mr-4">
                  <i className="ri-user-heart-line text-xl text-white"></i>
                </div>
                <h2 className="text-2xl font-semibold text-gray-900">3. Professional Communication</h2>
              </div>
              <ul className="list-disc pl-6 text-gray-700 space-y-2">
                <li>We treat every client, partner, and team member with respect and professionalism.</li>
                <li>Discrimination, harassment, or unethical behavior is not accepted in any form.</li>
              </ul>
            </section>

            <section className="mb-8">
              <div className="flex items-center mb-4">
                <div className="w-10 h-10 bg-blue-600 rounded-lg flex items-center justify-center mr-4">
                  <i className="ri-scales-line text-xl text-white"></i>
                </div>
                <h2 className="text-2xl font-semibold text-gray-900">4. Compliance and Ethics</h2>
              </div>
              <ul className="list-disc pl-6 text-gray-700 space-y-2">
                <li>We adhere to all applicable lending, advertising, and fair credit regulations.</li>
                <li>Every representative is expected to act within legal and ethical boundaries.</li>
              </ul>
            </section>

            <section className="mb-8">
              <div className="flex items-center mb-4">
                <div className="w-10 h-10 bg-blue-600 rounded-lg flex items-center justify-center mr-4">
                  <i className="ri-hand-heart-line text-xl text-white"></i>
                </div>
                <h2 className="text-2xl font-semibold text-gray-900">5. No Pressure Policy</h2>
              </div>
              <ul className="list-disc pl-6 text-gray-700 space-y-2">
                <li>We never pressure clients into decisions.</li>
                <li>Our role is to educate, guide, and provide clarity, not to sell aggressively.</li>
              </ul>
            </section>

            <section className="mb-8">
              <div className="flex items-center mb-4">
                <div className="w-10 h-10 bg-blue-600 rounded-lg flex items-center justify-center mr-4">
                  <i className="ri-focus-3-line text-xl text-white"></i>
                </div>
                <h2 className="text-2xl font-semibold text-gray-900">6. Client-Centered Approach</h2>
              </div>
              <ul className="list-disc pl-6 text-gray-700 space-y-2">
                <li>We prioritize the client's best interest over short-term gain.</li>
                <li>Every recommendation must align with the client's financial goals and capacity.</li>
              </ul>
            </section>

            <section className="mb-8">
              <div className="flex items-center mb-4">
                <div className="w-10 h-10 bg-blue-600 rounded-lg flex items-center justify-center mr-4">
                  <i className="ri-award-line text-xl text-white"></i>
                </div>
                <h2 className="text-2xl font-semibold text-gray-900">7. Responsible Representation</h2>
              </div>
              <ul className="list-disc pl-6 text-gray-700 space-y-2">
                <li>All marketing, online communication, and public interactions must reflect FFC's professionalism and accuracy.</li>
                <li>Misuse of company branding, confidential data, or client details is prohibited.</li>
              </ul>
            </section>

            <section className="mb-8">
              <div className="flex items-center mb-4">
                <div className="w-10 h-10 bg-blue-600 rounded-lg flex items-center justify-center mr-4">
                  <i className="ri-arrow-up-line text-xl text-white"></i>
                </div>
                <h2 className="text-2xl font-semibold text-gray-900">8. Continuous Improvement</h2>
              </div>
              <ul className="list-disc pl-6 text-gray-700 space-y-2">
                <li>We commit to ongoing training, financial education, and transparent feedback systems.</li>
                <li>Each team member is expected to grow personally and professionally.</li>
              </ul>
            </section>

            <section className="mb-8">
              <div className="bg-gray-50 border border-gray-200 rounded-lg p-8">
                <div className="flex items-center mb-4">
                  <div className="w-12 h-12 bg-blue-600 rounded-lg flex items-center justify-center mr-4">
                    <i className="ri-contract-line text-xl text-white"></i>
                  </div>
                  <h2 className="text-2xl font-semibold text-gray-900">Commitment Statement</h2>
                </div>
                <p className="text-gray-700 text-lg leading-relaxed">
                  By engaging with Fast Funding Capital, you agree to uphold this Code of Conduct in all business activities, client interactions, and representations of our brand.
                </p>
              </div>
            </section>

            <div className="text-center mt-12">
              <p className="text-gray-600 mb-4">Questions about our Code of Conduct?</p>
              <div className="bg-gray-50 p-6 rounded-lg">
                <p className="text-gray-700 mb-2"><strong>Fast Funding Capital</strong></p>
                <p className="text-gray-700 mb-2">2100 West Loop S Suite 800, Houston, TX 77027</p>
                <p className="text-gray-700 mb-2">Phone: 346.291.8220</p>
                <p className="text-gray-700">Email: info@fastfundingcap.com</p>
              </div>
            </div>

          </div>
        </div>
      </main>
      <Footer />
    </div>
  );
}